import { useMutation } from '@apollo/client';
import SAVE_USER_SETTING_MUTATION from 'graph/settings/settings-user/save-user-setting';
import { PliUserSetting } from 'store/types';

const useNavigationUserSetting = (): [
  { userSetting: any[]; loading: boolean },
  { updateLeftNavigationSetting: (open: boolean) => Promise<any> }
] => {
  const [updateUserSetting, { data: userSetting, loading }] = useMutation(
    SAVE_USER_SETTING_MUTATION
  );

  const updateLeftNavigationSetting = async (open: boolean) => {
    return await updateUserSetting({
      variables: {
        data: {
          setting: PliUserSetting.LEFT_NAVIGATION,
          value: {
            open
          }
        }
      }
    });
  };

  return [{ userSetting, loading }, { updateLeftNavigationSetting }];
};

export default useNavigationUserSetting;
